import { TableCard } from '../../../../components'
import { MinhaEscalaCalendario } from './components/MinhaEscalaCalendario'
import { MinhaEscalaHeader } from './components/MinhaEscalaHeader'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { MinhaEscalaTable } from './table/MinhaEscalaTable'

const MinhaEscala = () => (
  <>
    <TableCard className='mb-6'>
      <div className='card-header border-0 pt-6'>
        <div className='card-title'>
          <h3 className='card-label fw-bold text-gray-800'>Calendário</h3>
        </div>
      </div>
      <MinhaEscalaCalendario />
    </TableCard>

    <TableCard>
      <MinhaEscalaHeader />
      <MinhaEscalaTable />
    </TableCard>
  </>
)

export const MinhaEscalaWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <MinhaEscala />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
